import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { maskDriverName, isVisibleDriver, authHeaders } from "../utils/driverPrivacy";
import IracingPrivacyNotice from "./IracingPrivacyNotice";
import "../styles/WorldRecordsResultPage.css";

export const WorldRecordsResultPage = () => {
        const { car_id, track_id } = useParams();
        const location = useLocation();
        const [worldRecords, setWorldRecords] = useState(null);
        const [loading, setLoading] = useState(true);
        const [carName, setCarName] = useState(location.state?.carName || "");
        const [trackName, setTrackName] = useState(location.state?.trackName || "");
        const navigate = useNavigate();

        useEffect(() => {
                const fetchWorldRecords = async () => {
                        try {
                                const response = await fetch(`https://iracing6-backend.herokuapp.com/api/world-records/${car_id}/${track_id}`, { headers: authHeaders() });
                                if (response.ok) {
                                        const data = await response.json();
                                        setWorldRecords(data);
                                } else {
                                        console.error("Failed to fetch world records");
                                }
                        } catch (error) {
                                console.error("Error fetching world records:", error);
                        } finally {
                                setLoading(false);
                        }
                };

                fetchWorldRecords();
        }, [car_id, track_id]);

        useEffect(() => {
                if (!carName) {
                        const fetchCarName = async () => {
                                try {
                                        const carResponse = await fetch(`https://iracing6-backend.herokuapp.com/api/car-basic-info/getName/${car_id}`);
                                        if (carResponse.ok) {
                                                const carData = await carResponse.json();
                                                setCarName(carData);
                                        } else {
                                                console.error("Failed to fetch car name");
                                        }
                                } catch (error) {
                                        console.error("Error fetching car name:", error);
                                }
                        };
                        fetchCarName();
                }
        }, [car_id]);

        useEffect(() => {
                if (!trackName) {
                        const fetchTrackName = async () => {
                                try {
                                        const trackResponse = await fetch(`https://iracing6-backend.herokuapp.com/api/track-basic-info/getName/${track_id}`);
                                        if (trackResponse.ok) {
                                                const trackData = await trackResponse.json();
                                                setTrackName(trackData);
                                        } else {
                                                console.error("Failed to fetch track name");
                                        }
                                } catch (error) {
                                        console.error("Error fetching track name:", error);
                                }
                        };
                        fetchTrackName();
                }
        }, [track_id]);

        // Convert milliseconds to "mm:ss.SSS" format
        const formatLapTime = (milliseconds) => {
                return Math.floor(milliseconds / 10000 / 60) + ":" + ("0" + Math.floor((milliseconds / 10000) % 60)).slice(-2) + ":" + ("000" + (milliseconds % 10000)).slice(-4);
        };

        // Format date to mm-dd-yyyy
        const formatDate = (dateString) => {
                if (!dateString) return "";
                const date = new Date(dateString);
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const year = date.getFullYear();
                return `${month}-${day}-${year}`;
        };

        if (loading) {
                return (
                        <div className="wr-loading-container">
                                <div className="spinner"></div>
                        </div>
                );
        }

        // Show a message if there are no world records or if it's not an array
        if (!Array.isArray(worldRecords) || worldRecords.length === 0) {
                return (
                        <div className="no-wr-found-cont">
                                <div className="no-wr-found-div">No world records found for the selected car and track.</div>
                                <div className="go-to-search-wr-button1" onClick={() => navigate(`/worldrecords`)}>
                                        Go To Search
                                </div>
                        </div>
                );
        }

        // Helper to get source icon
        const getSourceIcon = (source) => {
                if (source === "telemetry") {
                        return <img src="/linechart_color.ico" alt="Telemetry" className="wrrp-source-icon" />;
                }
                return <img src="/iRacing-Icon-BW-White.png" alt="iRacing" className="wrrp-source-icon" />;
        };

        const tableFieldRows = worldRecords.map((record, index) => {
                if (index < 3) return null;

                return (
                        <div key={index} className="wrrp-table-row-f">
                                <div className="wrrptpos">{index + 1}</div>
                                <div className="wrrptl">
                                        <h1>{formatLapTime(record.race_lap_time)}</h1>
                                        <h2 onClick={() => isVisibleDriver(record.cust_id) && navigate(`/user/careerstats/${record.cust_id}`)}>{maskDriverName(record.display_name)}</h2>
                                </div>
                                <div className="wrrptrd">{formatDate(record.race_date)}</div>
                                <div className="wrrptsrc">{getSourceIcon(record.source)}</div>
                        </div>
                );
        });

        console.log(carName);

        return (
                <div className="world-records-result-page-cont">
                        <div className="wrrp-api-retired-banner">iRacing retired the World Records API in June 2025. Newer world records must now be submitted via telemetry.</div>
                        <div className="wrrp-title-div">
                                <h2>{carName}</h2> at <h2>{trackName}</h2>
                        </div>
                        <div className="wrrp-source-legend">
                                <div className="wrrp-source-legend-item">
                                        <img src="/iRacing-Icon-BW-White.png" alt="iRacing API" className="wrrp-source-icon" />
                                        <span>iRacing API</span>
                                </div>
                                <div className="wrrp-source-legend-item">
                                        <img src="/linechart_color.ico" alt="Telemetry" className="wrrp-source-icon" />
                                        <span>Telemetry (public only)</span>
                                        <Link to="/telemetry/upload" className="wrrp-upload-btn">
                                                Upload
                                        </Link>
                                </div>
                        </div>
                        <IracingPrivacyNotice />
                        <div className="wrrp-table-cont-div">
                                {/* <div className="wrrp-table-top-bar-div">top bar</div> */}
                                <div className="wrrp-table-top-3-flex">
                                        <div className="wrrp-table-top3-pos-cont">
                                                <div className="wrrp-table-top3-pos1">#1</div>
                                                <div className="wrrp-table-top3-pos2">#2</div>
                                                <div className="wrrp-table-top3-pos3">#3</div>
                                        </div>
                                        <div className="wrrp-table-top3-cont">
                                                <div className="wrrp-table-top3-1">
                                                        <h2>{formatLapTime(worldRecords[0].race_lap_time)}</h2>
                                                        <h1 onClick={() => isVisibleDriver(worldRecords[0].cust_id) && navigate(`/user/careerstats/${worldRecords[0].cust_id}`)}>{maskDriverName(worldRecords[0].display_name)}</h1>
                                                </div>
                                                <div className="wrrp-table-top3-2">
                                                        <h2>{formatLapTime(worldRecords[1].race_lap_time)}</h2>
                                                        <h1 onClick={() => isVisibleDriver(worldRecords[1].cust_id) && navigate(`/user/careerstats/${worldRecords[1].cust_id}`)}>{maskDriverName(worldRecords[1].display_name)}</h1>
                                                </div>
                                                <div className="wrrp-table-top3-3">
                                                        <h2>{formatLapTime(worldRecords[2].race_lap_time)}</h2>
                                                        <h1>{maskDriverName(worldRecords[2].display_name)}</h1>
                                                </div>
                                        </div>
                                        <div className="wrrp-table-top3-right-cont">
                                                <div className="wrrp-table-top3-right-1">{formatDate(worldRecords[0].race_date)}</div>
                                                <div className="wrrp-table-top3-right-2">{formatDate(worldRecords[1].race_date)}</div>
                                                <div className="wrrp-table-top3-right-3">{formatDate(worldRecords[2].race_date)}</div>
                                        </div>
                                        <div className="wrrp-table-top3-source-cont">
                                                <div className="wrrp-table-top3-source-1">{getSourceIcon(worldRecords[0].source)}</div>
                                                <div className="wrrp-table-top3-source-2">{getSourceIcon(worldRecords[1].source)}</div>
                                                <div className="wrrp-table-top3-source-3">{getSourceIcon(worldRecords[2].source)}</div>
                                        </div>
                                </div>
                        </div>

                        <div className="wrrp-table-field-row-cont">{tableFieldRows}</div>
                </div>
        );
};
